import {
  Button,
  Card,
  Stack,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import StyledButton from '../Button';

export const StyledContainer = styled(Stack)({
  width: '100%',
  gap: '16px',
});

export const StyledToggleKeyButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: '#080808',
  fontWeight: 700,
  fontSize: '16px',
  fontFamily: '"Inter", sans-serif',
  width: theme.spacing(20),
  '&:hover': {
    background: 'none',
  },
}));

export const StyledFormCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(144),
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  borderRadius: theme.spacing(1),
}));

export const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  background: '#ffffff',
  padding: theme.spacing(4),
  boxSizing: 'border-box',
  borderRadius: theme.spacing(2),
}));

export const StyledFormField = styled(TextField)(() => ({
  background: 'none',
  '.MuiInputLabel-root, .MuiFormLabel-root.Mui-focused, .MuiInputBase-input': {
    color: '#080808',
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#666666',
  },
  '.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#999999',
  },
}));

export const StyledFormInner = styled(Stack)(() => ({
  gap: '48px',
}));

export const StyledFieldSet = styled(Stack)(() => ({
  width: '100%',
  gap: '24px',
}));

export const StyledFieldSetTitle = styled(Typography)(() => ({}));
export const StyledSubmitButton = styled(StyledButton)(() => ({
  alignSelf: 'end',
  border: 'none',
  fontFamily: '"Inter", sans-serif',
}));

export const StyledHeader = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 700,
});

export const StyledRow = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
  '> *': {
    flex: 1,
  },
  gap: theme.spacing(4),
}));
